import { HttpClient, HttpHeaders } from '@angular/common/http';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
import { map } from 'rxjs/operators';
// Service imports
import { MPCacheRegistrationService } from '../../../../_services/shared-services/mp-cache-registration-service';
// constant imports
import { CacheDuration } from '../../../../_constants/cache-duration';
import { URLConstants } from '../../../../_constants/url-constants';
import { CashReceiptDetailResultDto } from '../../_models/cash-management/cash-receipts/cash-receipt-detail-result-dto';
import { CashReceiptPaymentTypeResultDto } from '../../_models/cash-management/cash-receipts/cash-receipt-payment-type-dto';
import { GLSubcategorySelectorResultDto } from '../../_models/common/gl-account/glsubcategory-selector-result-dto';
import { CashReceiptEditorResultDto } from '../../_models/cash-management/cash-receipts/cash-receipt-editor-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import { ReverseEditorResultDto } from '../../../../shared-module/_models/reverse-editor-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../_services/shared-services/mp-cache-registration-service";
export class CashReceiptService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getCashReceiptDetails(baseParams) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/detail/item${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(CashReceiptDetailResultDto, response)));
    }
    getPaymentType(baseParams) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/paymenttypes${baseParams.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParams.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(CashReceiptPaymentTypeResultDto, response)));
    }
    editCashReceipt(baseParams) {
        const url = URLConstants.ccCBCMCRBaseApiURL;
        return this.httpClient
            .put(url, classToPlain(baseParams))
            .pipe(map((response) => response.toString()));
    }
    reverseCashReceipt(baseParams) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/reverse`;
        return this.httpClient
            .put(url, classToPlain(baseParams))
            .pipe(map((response) => response.toString()));
    }
    deleteCashReceipt(baseParams) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}`;
        const options = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json'
            }),
            body: classToPlain(baseParams)
        };
        return this.httpClient.delete(url, options).pipe(map((response) => response.toString()));
    }
    addCashReceipt(baseParams) {
        const url = URLConstants.ccCBCMCRBaseApiURL;
        return this.httpClient
            .post(url, classToPlain(baseParams))
            .pipe(map((response) => response.toString()));
    }
    getSubCategories(params) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/subcategories${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(GLSubcategorySelectorResultDto, response)));
    }
    getEditor(params) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/editor${params.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, params.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(CashReceiptEditorResultDto, response)));
    }
    getTransactionLog(baseParam) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/history${baseParam.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, baseParam.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(TransactionLogResultDto, response)));
    }
    getReverseEditor(params) {
        const url = `${URLConstants.ccCBCMCRBaseApiURL}/reverse/editor${params.getQueryString()}`;
        return this.httpClient.get(url).pipe(map((response) => plainToClass(ReverseEditorResultDto, response)));
    }
}
CashReceiptService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CashReceiptService_Factory() { return new CashReceiptService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: CashReceiptService, providedIn: "root" });
